import { useAppContext } from "src/hooks/useAppContext";
import {
  TemplateCard,
  TemplateCardContainer,
  TemplateCards,
  TemplateLabel,
  LoaderContainer,
} from "./styles";
import { UUID } from "@screencloud/uuid";
import { OnboardingCommonAppInstanceTemplatesQuery } from "src/types.g";
import { getWhiteLabelStyles } from "src/helpers/whiteLabel";
import { Loader } from "@screencloud/screencloud-ui-components";

import {
  getIndustry,
  getAvailableTemplates,
  getPlaceholderTemplateByIndustry,
  trimTemplateName,
} from "../utils";

interface TemplateSelectionProps {
  loading: boolean;
  commonAppInstanceTemplates: OnboardingCommonAppInstanceTemplatesQuery["allCommonAppInstanceTemplates"];
  selectedTemplateIds: UUID[];
  handleTemplateClick: (templateId: UUID) => void;
}

export const TemplateSelection = ({
  loading,
  commonAppInstanceTemplates,
  selectedTemplateIds,
  handleTemplateClick,
}: TemplateSelectionProps) => {
  const context = useAppContext();
  const industry = getIndustry(context.currentOrg);
  const filteredTemplates = getAvailableTemplates({
    commonAppInstanceTemplates,
    industry,
  });
  const whiteLabelStyles = getWhiteLabelStyles(context);

  return (
    <TemplateCards>
      {loading ? (
        <LoaderContainer>
          <Loader
            data-testid="template-selection-loader"
            inline
            size="small"
            active
            className="loader"
          />
        </LoaderContainer>
      ) : (
        filteredTemplates?.map((template) => {
          return (
            <TemplateCardContainer
              key={template.id}
              color={whiteLabelStyles?.activeItemColor || "#FECF00"}
              isSelected={selectedTemplateIds.includes(template.id)}
              onClick={() => handleTemplateClick(template.id)}
            >
              <TemplateCard className="template-card" key={template.id}>
                <img
                  src={
                    getPlaceholderTemplateByIndustry({
                      templateName: template?.name || "",
                      industry,
                    }) || template?.commonFileByThumbnailFileId?.source
                  }
                  alt={template?.name || ""}
                />
              </TemplateCard>
              <TemplateLabel className="template-label">
                {trimTemplateName(template?.name || "")}
              </TemplateLabel>
            </TemplateCardContainer>
          );
        })
      )}
    </TemplateCards>
  );
};
